<template>
    <div :class="columnClass">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            width: { type: Number, required: false, default: 0 },
        },

        computed: {
            columnClass() {
                return {
                    grid__column: true,
                    [`grid__column--width-${this.width}`]: true,
                }
            },
        },
    }
</script>
